module.exports = "../images/lake@2x.png?v=b9db351";